/** Authored display copy for the approved Sales presentation audit. API values and user data remain unchanged. */
export const targetsAuditArabicTranslations: Record<string, string> = {
  'Allocation cleared for the selected month only': 'تم مسح التوزيع للشهر المختار فقط',
  'Set this employee to No Target for {0} only. Other months are preserved.': 'الموظف ده هيبقى من غير تارجت في {0} فقط. باقي الشهور هتفضل زي ما هي.',
  'Search salesperson or course': 'دوّر على موظف أو كورس',
  'Search competitions': 'دوّر على مسابقة',
  'Target status': 'حالة التارجت',
  'All targets': 'كل التارجتات',
  'Assigned targets': 'التارجتات المتوزّعة',
  'Below target': 'لسه محققش التارجت',
  'No target': 'من غير تارجت',
  'Competition status': 'حالة المسابقة',
  'Active and scheduled': 'الجارية والقادمة',
  'All competitions': 'كل المسابقات',
  'Company target': 'تارجت الشركة',
  'Breakdown': 'التفاصيل',
  'Achieved targets': 'التارجتات اللي اتحققت',

  'Network error loading data': 'مش قادرين نحمّل البيانات. جرّب تاني.',
  'Save dates': 'احفظ التواريخ',
  'Choose month': 'اختار شهر',
  'Next Action cannot be set in the past.': 'ميعاد الخطوة الجاية مينفعش يكون في الماضي.',
  '{0} selected tasks': '{0} مهام مختارة',
  'Each selected task records completion and clears its own trigger when a direct resolver exists.': 'كل مهمة مختارة بيتسجل إنها خلصت، وسبب ظهورها بيتقفل لو فيه إجراء مباشر بيحلّه.',
  'Resolve the lead action or reschedule the next follow-up.': 'نفّذ إجراء العميل أو غيّر ميعاد المتابعة الجاية.',
  'Unable to load activity history': 'مش قادرين نحمّل سجل النشاط',
  'Record what happened before completing the follow-up': 'سجّل اللي حصل قبل ما تنهي المتابعة',
  'Review requests submitted': 'تم إرسال طلبات المراجعة',
  'Review request submitted': 'تم إرسال طلب المراجعة',
  '{0} task(s) completed': 'تم إنهاء {0} مهمة',
  '{0} task(s) snoozed': 'تم تأجيل {0} مهمة',
  '{0} task(s) rescheduled': 'تم تغيير موعد {0} مهمة',
  'Snooze requires date and time': 'التأجيل محتاج تاريخ ووقت',
  'Reschedule requires date and time': 'تغيير الموعد محتاج تاريخ ووقت',
  'Snooze requires a valid date and time': 'اختار تاريخ ووقت صحيحين للتأجيل',
  'Reschedule requires a valid date and time': 'اختار تاريخ ووقت صحيحين لتغيير الموعد',
  'Unable to snooze task(s)': 'مش قادرين نأجل المهام',
  'Unable to reschedule task(s)': 'مش قادرين نغيّر موعد المهام',
  'Unable to complete tasks': 'مش قادرين ننهي المهام',
  'Unable to open quick action': 'مش قادرين نفتح الإجراء السريع',
  'Unable to submit review requests': 'مش قادرين نرسل طلبات المراجعة',
  'Unable to submit review request': 'مش قادرين نرسل طلب المراجعة',
  'Unable to load daily queue': 'مش قادرين نحمّل قائمة الشغل اليومية',
  'Bonus approved': 'تمت الموافقة على المكافأة',
  'Bonus waived': 'تم إعفاء المكافأة',
  'Penalty approved': 'تمت الموافقة على الخصم',
  'Penalty waived': 'تم الإعفاء من الخصم',
  'CUSTOMER DIRECTORY': 'دليل العملاء',
  'CUSTOMER PROFILE': 'ملف العميل',
  'All customers': 'كل العملاء',
  'My customers': 'عملائي',
  'Find a customer and review their bookings and reception history before your next call.': 'ابحث عن العميل وراجع حجوزاته وسجل الريسبشن قبل المكالمة الجاية.',
  'Search customers': 'ابحث عن عميل',
  'Search by name, phone or student code': 'ابحث بالاسم أو رقم التليفون أو كود الطالب',
  'Customer filters are waiting for the server update.': 'فلاتر العملاء مستنية تحديث السيرفر.',
  'Responsible employee': 'الموظف المسؤول',
  'Filter by responsible employee': 'فلتر بالموظف المسؤول',
  'Customer file': 'ملف العميل',
  'Filter by customer file': 'فلتر حسب ملف العميل',
  'Linked customer file': 'ملف عميل مرتبط',
  'Not linked yet': 'لسه مش مرتبط',
  'Sort by': 'ترتيب حسب',
  'Sort customers': 'ترتيب العملاء',
  'Default order': 'الترتيب الأساسي',
  'Customer name (A–Z)': 'اسم العميل أبجديًا',
  'Loading customers…': 'جاري تحميل العملاء…',
  'Student code:': 'كود الطالب:',
  'View history': 'عرض السجل',
  'View history for {0}': 'عرض سجل {0}',
  'Customer pages': 'صفحات العملاء',
  'Previous customers': 'العملاء السابقين',
  'Next customers': 'العملاء التاليين',
  'Customer history': 'سجل العميل',
  'Close history': 'اقفل السجل',
  'Refresh history': 'تحديث السجل',
  'Before the call': 'قبل المكالمة',
  'Current groups': 'الجروبات الحالية',
  'No group assigned.': 'مفيش جروب متحدد.',
  'No history recorded.': 'مفيش سجل متسجل.',
  'Previous history': 'السجل السابق',
  'Next history': 'السجل التالي',
  'on this page': 'في الصفحة دي',
  'customers found': 'عميل في نتائج البحث',
  'Could not load customers.': 'مش قادرين نحمّل العملاء.',
  'Could not load customer history.': 'مش قادرين نحمّل سجل العميل.',
  'This customer is no longer assigned to you.': 'العميل ده مبقاش متعيّن ليك.',
  'No customers found.': 'مفيش عملاء مطابقين للبحث.',
  'No customers assigned to you.': 'مفيش عملاء متعيّنين ليك.',
  'Customer summary': 'ملخص العميل',
  'Not provided': 'مش متوفر',
  'Not yet approved': 'لسه متوافقش عليه',
  'Recorded by {0}': 'سجّله {0}',
  'Recorded employee unavailable': 'الموظف اللي سجّل النشاط مش متوفر',
  'Customer activity': 'نشاط العميل',
  'Placement test result': 'نتيجة تحديد المستوى',
  'Reception note': 'ملاحظة الريسبشن',
  'Reception activity': 'نشاط الريسبشن',
  'Sales activity': 'نشاط السيلز',
  'Voided receipt': 'إيصال ملغي',
  'Payment request': 'طلب دفع',
  'Payment review': 'مراجعة الدفع',
  'Waiting request': 'طلب انتظار',
  'Waiting resolved': 'طلب الانتظار اتحل',
  'Branch transfer': 'نقل الفرع',
  'Refund request': 'طلب استرداد',
  'Refund completed': 'الاسترداد اكتمل',
  'Award performer': 'صرف جايزة للموظف',
  'Waive': 'إعفاء',
  'WINNER': 'الفائز',
  'View Company Breakdown': 'عرض تفاصيل تارجت الشركة',
  'Some target information could not be loaded.': 'مش قادرين نحمّل بعض بيانات التارجت.',
  'Competition details could not be loaded.': 'مش قادرين نحمّل تفاصيل المسابقة.',
  'Review amount': 'مبلغ المراجعة',
  'Review item': 'البند المطلوب مراجعته',
  'Decision': 'القرار',
  '{0} assignments': '{0} توزيع',
  '{0} active': '{0} نشط',
  '{0} closed months': '{0} شهر مقفول',
  '{0}h late': 'متأخر {0} ساعة',
  '{0}d late': 'متأخر {0} يوم',
  '{0} events': '{0} نشاط',
  'Activity note': 'ملاحظة النشاط',
  'Activity type': 'نوع النشاط',
  'Activity visibility': 'ظهور النشاط',
  'Employee #{0}': 'الموظف #{0}',
  'System': 'النظام',
  'contact': 'تواصل',
  'workflow': 'متابعة الشغل',
  'task': 'مهمة',
  'note': 'ملاحظة',
  'transfer': 'نقل',
  'review': 'مراجعة',
  'conversion': 'تحويل',
  'salary_percent': 'نسبة من المرتب',
  'work_day': 'يوم عمل',
  'warning': 'تنبيه',
  'count': 'عدد',
  'percent': 'نسبة مئوية',
  'Submit': 'إرسال',
  'Inactive': 'غير نشط',
  'Bonus': 'مكافأة',
  'Penalty': 'خصم',
  'This line will be removed from the company target calculation.': 'البند ده هيتشال من حساب تارجت الشركة.',
  'This course line will no longer count toward the salesperson target.': 'بند الكورس ده مش هيتحسب ضمن تارجت الموظف.',
  'Set this employee to No Target from {0} onward until another allocation is set. Earlier months are preserved.': 'الموظف ده هيبقى من غير تارجت من {0} لحد ما يتحدد له توزيع تاني. الشهور السابقة هتفضل زي ما هي.',
  'Award {0} the competition prize? This action records the winner and bonus.': 'تصرف جايزة المسابقة لـ {0}؟ الإجراء ده بيسجّل الفائز والمكافأة.',
  '{0} will stop receiving leads. Course assignments stay visible for history.': '{0} مش هيستقبل ليدز جديدة. توزيع الكورسات هيفضل ظاهر في السجل.',
  'Create review requests for {0} selected task(s)?': 'تعمل طلبات مراجعة لـ {0} مهمة متعلّمة؟',
  'None': 'مفيش',
  'Not closed': 'لسه متقفلتش',
  '{0} to review': '{0} محتاج مراجعة',
  'Show This Week': 'اعرض الأسبوع ده',
  'View Tasks': 'عرض المهام',
  'View Pipeline': 'عرض البايبلاين',
  '{0} enrollments': '{0} تسجيل',
  'Course already assigned': 'الكورس ده متوزّع بالفعل',
  'End date must be after start date': 'تاريخ النهاية لازم يكون بعد تاريخ البداية',
};

export const targetsAuditEnglishTranslations: Record<string, string> = {};
